import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPosts } from "state";
import PostWidget from "./PostWidget";

const PostsWidget = ({ userId, isProfile = false }) => {
  const dispatch = useDispatch();

  const posts = useSelector((state) => state.posts);
  const token = useSelector((state) => state.token);
  const baseurl = process.env.REACT_APP_BASE_URL;

  const getPosts = async () => {
    const response = await fetch(`${baseurl}/posts`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    dispatch(setPosts({ posts: data }));
  };

  const getUserPosts = async () => {
    if (!userId) { dispatch(setPosts({ posts: {} })); return; }
    const response = await fetch(
      `${baseurl}/posts/${userId}/posts`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const data = await response.json();
    dispatch(setPosts({ posts: data }));
  };

  useEffect(() => {
    if (isProfile) {
      getUserPosts();
    } else {
      getPosts();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!posts || posts.error) return null;
  return (
    <>
      {posts.map(
        ({
          _id,
          userId,
          userName,
          firstName,
          lastName,
          description,
          createdAt,
          location,
          picturePath,
          url,
          userPicturePath,
          likes,
          comments,
        }) => (
          <PostWidget
            key={_id}
            postId={_id}
            postUserId={userId}
            postUserName={userName}
            description={description}
            createdAt={createdAt}
            location={location}
            picturePath={picturePath}
            url={url}
            userPicturePath={userPicturePath}
            likes={likes}
            comments={comments}
          />
        )
      )}
    </>
  );
};

export default PostsWidget;
